import { render, staticRenderFns } from "./BreakingChangeConfirm.vue?vue&type=template&id=f9db6920&scoped=true&"
import script from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts&"
export * from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./BreakingChangeConfirm.vue?vue&type=style&index=0&id=f9db6920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9db6920",
  null
  
)

export default component.exports